<template>
  <v-navigation-drawer
    v-model="mini"
    :mini-variant.sync="mini"
    app
    disable-resize-watcher
    permanent
    class="drawer-color"
    color="#262D37"
    style="z-index:20"
    width="150"
    mini-variant-width="52"
  >
    <div
      :class="[
        mini ? 'justify-center' : '',
        'height-48 d-flex align-center pa-2',
      ]"
    >
      <img
        src="/static/topper/메뉴.svg"
        width="32"
        height="48"
        @click="mini = !mini"
        class="cursor-pointer"
      />
      <h4 class="pl-2" v-if="!mini">
        Menu
      </h4>
      <span v-if="!mini" class="algin-center d-flex justify-center height-48">
      </span>
    </div>
    <v-list nav dense class="pa-0">
      <v-list-item-group
        active-class=" text--accent-4 back-52ABEB "
        class="pa-0"
        v-model="listGroup"
      >
        <v-list-item
          v-for="(menu, index) in menuList"
          :key="index"
          @click="menu.action($bus, $router, $store)"
          class="color-white border-bottom-191E26"
          :class="menu.styleClass ? menu.styleClass : ''"
        >
          <img :src="menu.img" />
          <v-list-item-title class="ml-4">
            <h3>{{ menu.menuName }}</h3>
          </v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <template v-slot:append>
      <div class="pa-2 d-flex justify-end" @click="logout()">
        <img
          src="/static/login/Logout.svg"
          :style="mini == true ? 'margin-right:15px;' : ''"
        />
        <v-btn text color="#8999A4" v-if="!mini">
          Logout
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import UserApi from "../api/UserService";
import Commonality from "../mixin/Commonality";
import { makeMenuList } from "./js/Drawer";
export default {
  mixins: [Commonality],
  created: function() {
    this.$bus.$on("opentheDoor", () => {
      this.mini = !this.mini;
    });
    this.$bus.$on("changeListGroup", this.changeList);
    this.setActiveMenu();
  },
  beforeDestroy() {
    this.$bus.$off("changeListGroup");
  },
  data: function() {
    return {
      openDrawer: false,
      mini: true,
      listGroup: 0,
    };
  },
  computed: {
    menuList() {
      return makeMenuList(this.userState, this.constructionId);
    },
    curPath() {
      return this.$route.path;
    },
  },
  watch: {
    /** 뒤로가기 시 해당 menu 활성화 */
    curPath(val, oldVal) {
      if (val !== oldVal) {
        this.setActiveMenu();
      }
    },
  },

  methods: {
    changeList(payload) {
      let index = this.menuList.findIndex((menu) => menu.menuName == payload);
      if (index != this.listGroup) {
        this.listGroup = index;
      }
    },
    moveMenu(menu) {
      this.$bus.$emit("loadingStart");
      this.$router.push({ name: menu }).catch(() => {
        //this.$router.go(this.$router.currentRoute)
        this.$bus.$emit(menu + "NavigationDuplicated");
        this.$bus.$emit("loadingEnd");
      });
      this.$bus.$emit("loadingEnd");
    },
    async logout() {
      let returnData = await UserApi.userLogout();
      if (returnData.data.success === "ok") {
        await this.$bus.$emit("dialog", "로그아웃되셨습니다.");
        this.$store.commit("constructionIdChange", null);
        this.$store.commit("userStateChange", null);
        this.$store.commit("userListChange", null);
        // this.$store.commit("projectName", null);
        this.$store.commit("resetStoreFilter");
        this.$router.push({ name: "Login" });
      }
    },
    /** 새로고침해도 현재path를 기준으로 클릭된 menu 활성화하기 */
    setActiveMenu() {
      const curPath = this.$route.path?.replace("/", "");
      const routes = {
        dashBoard: 0,
        orderinvoice: 1,
        order: 2,
        invoice: 3,
        store: 4,
        approval: 5,
        construction: 6,
        company: 7,
        user: 8,
      };
      this.listGroup = routes[curPath];
    },
  },
};
</script>

<style scoped>
.height-48 {
  height: 48px;
}
.drawer-color {
  color: white;
  background: #262d37;
}

h3 {
  color: white;
}

.back-52ABEB {
  background: linear-gradient(97.45deg, #68bae8 33.73%, #52abeb 85.22%), #ffffff;
}
.border-bottom-191E26 {
  border-bottom: thin solid #191e26 !important;
}
.border-top-191E26 {
  border-top: thin solid #191e26 !important;
}
</style>
